import { FlaskConical, BookOpenCheck, Leaf } from "lucide-react";
import { motion } from "framer-motion";

const HalalIcon = () => (
  <div className="flex h-16 w-16 items-center justify-center overflow-hidden rounded-full border-2 border-white/40 bg-white shadow-lg">
    <img
      src="/assets/halal-mark.png"
      alt="Halal certified by JAKIM"
      className="h-12 w-12 object-contain"
    />
  </div>
);

const ITEMS = [
  { icon: <FlaskConical className="h-12 w-12" strokeWidth={1.3} />, lines: ["4 Clinically", "Studied", "Ingredients"] },
  { icon: <BookOpenCheck className="h-12 w-12" strokeWidth={1.3} />, lines: ["Backed by", "Scientific", "Research"] },
  { icon: <HalalIcon />, lines: ["Halal", "Certified", ""], testid: "trust-halal", href: "/assets/halal-certificate.png" },
  { icon: <Leaf className="h-12 w-12" strokeWidth={1.3} />, lines: ["Suitable for", "Long-term", "Use"] },
];

export default function TrustBar() {
  return (
    <section
      id="about"
      data-testid="trust-bar"
      className="relative bg-fv-navy py-20 lg:py-24"
    >
      <div className="mx-auto grid max-w-7xl grid-cols-2 gap-y-12 px-5 md:grid-cols-4 lg:px-8">
        {ITEMS.map((item, i) => {
          const content = (
            <>
              <div className="flex h-16 items-center text-fv-cyan transition-transform duration-500 group-hover:scale-110">
                {item.icon}
              </div>
              <div className="font-display text-lg font-bold leading-snug text-white md:text-xl">
                {item.lines.map((l, j) => (
                  <span key={j} className="block">
                    {l}
                  </span>
                ))}
              </div>
              {item.href && (
                <span className="text-[10px] font-bold tracking-[0.2em] text-fv-cyan/70 underline underline-offset-4">
                  VIEW CERTIFICATE
                </span>
              )}
            </>
          );
          return (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 28 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, delay: i * 0.1, ease: [0.22, 1, 0.36, 1] }}
              className={`px-4 ${i > 0 ? "md:border-l md:border-white/10" : ""}`}
            >
              {item.href ? (
                <a
                  href={item.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid={item.testid}
                  className="group flex flex-col items-center gap-5 text-center"
                  title="View Halal certificate"
                >
                  {content}
                </a>
              ) : (
                <div
                  data-testid={item.testid || `trust-item-${i}`}
                  className="group flex flex-col items-center gap-5 text-center"
                >
                  {content}
                </div>
              )}
            </motion.div>
          );
        })}
      </div>
    </section>
  );
}
